import type { USER_INFO_SHORT, USER_PROFILE } from '@/views/screens/Profile/types';

import { DEFAULT_LANGUAGE } from '../../contants/common';
import { DEFAULT_STORE_OBJECT } from '../constants';
import type { DefaultStoreObject } from '../types';
import AuthTypes from './AuthTypes';

// biome-ignore lint/suspicious/noExplicitAny: TODO: fix
export interface AuthState extends Record<string, any> {
  user: DefaultStoreObject<USER_INFO_SHORT> & {
    loginStatus: boolean;
    language: string;
  };
  userProfile: DefaultStoreObject<USER_PROFILE>;
}

const initialState: AuthState = {
  approveRejectShipment: { ...DEFAULT_STORE_OBJECT },
  changeCompany: { ...DEFAULT_STORE_OBJECT },
  getUserPreference: { ...DEFAULT_STORE_OBJECT, data: {} },
  menus: { ...DEFAULT_STORE_OBJECT },
  menusItems: { ...DEFAULT_STORE_OBJECT },
  selectedCompany: false,
  user: {
    ...DEFAULT_STORE_OBJECT,
    data: null,
    language: DEFAULT_LANGUAGE,
    loginStatus: false,
  },
  userProfile: { ...DEFAULT_STORE_OBJECT },
};

// biome-ignore lint/suspicious/noExplicitAny: TODO: fix
const AuthReducer = (state = initialState, { type, payload }: any): AuthState => {
  switch (type) {
    case AuthTypes.LOGIN_IN_SUCCESS: {
      return {
        ...state,
        user: {
          ...DEFAULT_STORE_OBJECT,
          loginStatus: true,
          success: true,
          ...payload,
        },
      };
    }

    case AuthTypes.GET_USER_MENU_PROGRESS: {
      return {
        ...state,
        menus: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          ...payload,
        },
      };
    }

    case AuthTypes.GET_USER_MENU_SUCCESS: {
      return {
        ...state,
        menus: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }

    case AuthTypes.GET_USER_MENU_ERROR: {
      return {
        ...state,
        menus: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    case AuthTypes.GET_USER_MENU_ITEMS_PROGRESS: {
      return {
        ...state,
        menusItems: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          ...payload,
        },
      };
    }

    case AuthTypes.GET_USER_MENU_ITEMS_SUCCESS: {
      return {
        ...state,
        menusItems: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }

    case AuthTypes.GET_USER_MENU_ITEMS_ERROR: {
      return {
        ...state,
        menusItems: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    case AuthTypes.SET_SELECTED_COMPANY: {
      localStorage.setItem('selectedCompanyId', payload?.companyId || '');
      return {
        ...state,
        selectedCompany: payload,
      };
    }

    case AuthTypes.GET_USER_PROFILE_PROGRESS: {
      return {
        ...state,
        userProfile: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          ...payload,
        },
      };
    }

    case AuthTypes.GET_USER_PROFILE_SUCCESS: {
      return {
        ...state,
        userProfile: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }

    case AuthTypes.GET_USER_PROFILE_ERROR: {
      return {
        ...state,
        userProfile: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    case AuthTypes.GET_USER_PREFERENCE_PROGRESS: {
      return {
        ...state,
        getUserPreference: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          ...payload,
        },
      };
    }
    case AuthTypes.GET_USER_PREFERENCE_SUCCESS: {
      return {
        ...state,
        getUserPreference: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }
    case AuthTypes.GET_USER_PREFERENCE_ERROR: {
      return {
        ...state,
        getUserPreference: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    case AuthTypes.CHANGE_COMPANY_IN_PROGRESS: {
      return {
        ...state,
        changeCompany: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          ...payload,
        },
      };
    }
    case AuthTypes.CHANGE_COMPANY_IN_SUCCESS: {
      return {
        ...state,
        changeCompany: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }
    case AuthTypes.CHANGE_COMPANY_IN_FAIL: {
      return {
        ...state,
        changeCompany: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    case AuthTypes.APPROVE_REJECT_SHIPMENT_IN_PROGRESS: {
      return {
        ...state,
        approveRejectShipment: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          ...payload,
        },
      };
    }
    case AuthTypes.APPROVE_REJECT_SHIPMENT_IN_SUCCESS: {
      return {
        ...state,
        approveRejectShipment: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }
    case AuthTypes.APPROVE_REJECT_SHIPMENT_IN_FAIL: {
      return {
        ...state,
        approveRejectShipment: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default AuthReducer;
